// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jwGmQ","importantInfo":"styles_importantInfo__2Teyu"};